import React from "react";
import { useFormik } from 'formik';
import izenuAPI from '../../services/izenuAPI';

export default function AdminUsers() {

    const [loading, setLoading] = React.useState(null);
    const [users, setUsers] = React.useState([]);
    const [editingId, setEditingId] = React.useState(null);
    const [editData, setEditData] = React.useState({});

    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            pwd: '',
            contact: '',
        },
        onSubmit: values => {
            registerUser(values);
        },
    });

    const registerUser = React.useCallback(async (data) => {
        setLoading(true);
        try {
            const { data: r } = await izenuAPI.post("/admin/user/insert.php", data);
            if (r.response) {
                alert("Conta criada com sucesso!");
                formik.resetForm();
                fetchUsers();
            } else {
                alert(r.message || "Impossível criar conta, tente mais tarde!");
            }
        } catch (e) {
            alert("Erro ao criar conta");
        }
        setLoading(false);
    });

    const deleteUser = React.useCallback(async (user) => {
        if (!window.confirm(`Tem certeza que deseja remover ${user.name || user.email}?`)) return;
        try {
            const { data: r } = await izenuAPI.get(`/admin/user/delete.php?user_id=${user.user_id}`);
            if (r.response) {
                fetchUsers();
            } else {
                alert("Erro ao remover administrador");
            }
        } catch (e) {
            alert("Erro ao remover administrador");
        }
    });

    const startEdit = React.useCallback((user) => {
        setEditingId(user.user_id);
        setEditData({
            name: user.name || '',
            email: user.email || '',
            contact: user.contact || '',
            password: '',
        });
    });

    const cancelEdit = React.useCallback(() => {
        setEditingId(null);
        setEditData({});
    });

    const saveEdit = React.useCallback(async () => {
        try {
            const payload = { user_id: editingId };
            if (editData.name) payload.name = editData.name;
            if (editData.email) payload.email = editData.email;
            if (editData.contact) payload.contact = editData.contact;
            if (editData.password) payload.password = editData.password;

            const { data: r } = await izenuAPI.post("/admin/user/update.php", payload);
            if (r.response) {
                setEditingId(null);
                setEditData({});
                fetchUsers();
            } else {
                alert(r.message || "Erro ao atualizar");
            }
        } catch (e) {
            alert("Erro ao atualizar administrador");
        }
    });

    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const d = new Date(dateStr);
        return d.toLocaleDateString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' });
    };

    const renderUsers = React.useCallback(() => {
        if (users.length > 0) {
            return (<>{users.map((e, i) => {
                const isEditing = editingId === e.user_id;

                if (isEditing) {
                    return (
                        <div key={e.user_id} className="border p-3 sm:p-4 mb-3 rounded-lg bg-gray-50">
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                                <div>
                                    <label className="block mb-1 text-sm font-medium text-gray-700 text-left">Nome</label>
                                    <input type="text" value={editData.name} onChange={(ev) => setEditData({...editData, name: ev.target.value})}
                                        className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2" />
                                </div>
                                <div>
                                    <label className="block mb-1 text-sm font-medium text-gray-700 text-left">Email</label>
                                    <input type="email" value={editData.email} onChange={(ev) => setEditData({...editData, email: ev.target.value})}
                                        className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2" />
                                </div>
                                <div>
                                    <label className="block mb-1 text-sm font-medium text-gray-700 text-left">Contacto</label>
                                    <input type="text" value={editData.contact} onChange={(ev) => setEditData({...editData, contact: ev.target.value})}
                                        className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2" />
                                </div>
                                <div>
                                    <label className="block mb-1 text-sm font-medium text-gray-700 text-left">Nova palavra-passe (deixar vazio para manter)</label>
                                    <input type="password" value={editData.password} onChange={(ev) => setEditData({...editData, password: ev.target.value})}
                                        className="border border-gray-300 text-gray-900 text-sm rounded-lg block w-full p-2" placeholder="••••••" />
                                </div>
                                <div className="sm:col-span-2 flex gap-2">
                                    <button onClick={saveEdit} className="text-sm px-4 py-2 font-medium bg-amber-500 text-white rounded-lg hover:bg-amber-600">
                                        Guardar
                                    </button>
                                    <button onClick={cancelEdit} className="text-sm px-4 py-2 font-medium bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400">
                                        Cancelar
                                    </button>
                                </div>
                            </div>
                        </div>
                    );
                }

                return (
                    <div key={e.user_id} className="border p-3 flex gap-3 sm:gap-4 mb-3 items-center rounded-lg">
                        <div className="rounded-full bg-gray-300 h-10 w-10 sm:h-12 sm:w-12 flex-shrink-0 flex items-center justify-center">
                            <svg className="text-gray-500 h-10 w-10 sm:h-12 sm:w-12" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 20">
                                <path d="M10 0a10 10 0 1 0 10 10A10.011 10.011 0 0 0 10 0Zm0 5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 13a8.949 8.949 0 0 1-4.951-1.488A3.987 3.987 0 0 1 9 13h2a3.987 3.987 0 0 1 3.951 3.512A8.949 8.949 0 0 1 10 18Z" />
                            </svg>
                        </div>
                        <div className="flex-1 min-w-0">
                            <h3 className="p-0 m-0 text-left font-semibold text-gray-900">{e.name || '(sem nome)'}</h3>
                            <p className="p-0 m-0 text-left text-sm text-gray-600 break-all">{e.email}</p>
                            <p className="p-0 m-0 text-left text-sm text-gray-500">{e.contact}{e.contact && e.create_at ? ' · ' : ''}<span className="whitespace-nowrap">{formatDate(e.create_at)}</span></p>
                        </div>
                        <div className="flex gap-0.5 sm:gap-2 flex-shrink-0">
                            <button onClick={() => startEdit(e)} className="p-2 text-gray-500 hover:text-amber-500 rounded-lg hover:bg-gray-100" title="Editar">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                </svg>
                            </button>
                            <button onClick={() => deleteUser(e)} className="p-2 text-gray-500 hover:text-red-500 rounded-lg hover:bg-gray-100" title="Remover">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                </svg>
                            </button>
                        </div>
                    </div>
                );
            })}</>);
        } else {
            return (<div className="justify-center items-center h-full flex">
                <h1 className="text-grey-500 font-light text-xl">Nenhum administrador encontrado</h1>
            </div>);
        }
    }, [users, editingId, editData]);

    const fetchUsers = React.useCallback(async () => {
        setLoading(true);
        const { data: r } = await izenuAPI.post("/admin/user/fetchAll.php");
        if (r.response) {
            setUsers(r.users);
        }
        setLoading(false);
    });

    React.useEffect(() => {
        fetchUsers();
    }, []);

    if (loading && users.length === 0) {
        return (<div className="justify-center items-center flex flex-col h-full border p-5 rounded-lg">
            <div role="status">
                <svg aria-hidden="true" className="inline w-8 h-8 text-gray-200 animate-spin fill-yellow-400" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                    <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                </svg>
            </div>
            <h1 className="text-amber-500 font-light text-3xl mt-4">A carregar...</h1>
        </div>);
    }

    return (<div className="max-w-6xl mx-auto text-left">
        <h1 className="text-xl sm:text-2xl font-bold text-gray-900 mb-4 sm:mb-6">Administradores ({users.length})</h1>
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-4 sm:gap-6 items-start">

            <section className="lg:col-span-3 border rounded-xl p-3 sm:p-5 bg-white">
                {renderUsers()}
            </section>

            <section className="lg:col-span-2 border rounded-xl p-3 sm:p-5 bg-white">
                <h2 className="font-semibold text-gray-900 mb-3">Adicionar administrador</h2>
                <form onSubmit={formik.handleSubmit}>
                    <label className="block mb-2 text-sm font-medium text-gray-900 text-left">Nome</label>
                    <div className="relative mb-4">
                        <input type="text" name="name" onChange={formik.handleChange} value={formik.values.name}
                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-amber-500 block w-full p-2.5" placeholder="Nome completo" />
                    </div>
                    <label className="block mb-2 text-sm font-medium text-gray-900 text-left">Email</label>
                    <div className="relative mb-4">
                        <div className="absolute inset-y-0 start-0 flex items-center ps-3.5 pointer-events-none">
                            <svg className="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 16">
                                <path d="m10.036 8.278 9.258-7.79A1.979 1.979 0 0 0 18 0H2A1.987 1.987 0 0 0 .641.541l9.395 7.737Z" />
                                <path d="M11.241 9.817c-.36.275-.801.425-1.255.427-.428 0-.845-.138-1.187-.395L0 2.6V14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2.5l-8.759 7.317Z" />
                            </svg>
                        </div>
                        <input type="email" name="email" onChange={formik.handleChange} value={formik.values.email}
                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-amber-500 block w-full ps-10 p-2.5" placeholder="nome@izenu.ao" />
                    </div>
                    <label className="block mb-2 text-sm font-medium text-gray-900 text-left">Contacto</label>
                    <div className="relative mb-4">
                        <input type="text" name="contact" onChange={formik.handleChange} value={formik.values.contact}
                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-amber-500 block w-full p-2.5" placeholder="+244 9XX XXX XXX" />
                    </div>
                    <label className="block mb-2 text-sm font-medium text-gray-900 text-left">Palavra-passe</label>
                    <div className="relative mb-6">
                        <input type="password" name="pwd" onChange={formik.handleChange} value={formik.values.pwd}
                            className="border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-amber-500 block w-full p-2.5" placeholder="Palavra-passe" />
                    </div>
                    <div className="relative mb-6 flex flex-row">
                        <button type="submit" className="w-full sm:w-auto text-sm px-4 py-2.5 font-medium bg-amber-500 !text-white rounded-lg hover:bg-amber-600">
                            Adicionar administrador
                        </button>
                    </div>
                </form>
            </section>
        </div>
    </div>);
}
